/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Базовая вью для выбора количества заказываемой услуги
   */
  app.ServiceItemQtyView = app.ItemQtyView.extend({
    el: '.btn-block',
    
    run: function (options) {
      if (options && options.cart && options.cart instanceof app.Cart) {
        this.cart = options.cart;
      }
      if (options && options.item) {
        this.item = options.item;
      }
      /**
       * Переопределяем родительские события, чтобы нажатие на кнопку работало отдельно от увеличения количества.
       */
      var events = _.omit(this.events, ['click [data-cart-link], [data-item-inc]']);
      this.delegateEvents(_.extend(events, {
        'click [data-item-inc]': 'increaseQty',
        'click [data-cart-link]': 'sendCheckoutEvent'
      }));
      this.listenTo(this.model, 'change:qty', this.render);
    },
    /**
     * @inheritdoc
     */
    addCartItemToCart: function () {
      this.model.set('qty', null);
    },
    /**
     * Сохраняет в модель обновленное и отфильтрованное значение количества
     */
    addToCartPrev: function () {
      this.model.set('qty', this.value);
    },
    /**
     * @inheritdoc
     */
    updateQty: function () {
      this.addToCartPrev();
    },
    /**
     * @inheritdoc
     */
    removeFromCart: function() {
      this.model.set('qty', null);
    },
    /**
     * Отправляет событие о необходимости продолжить оформление услуги при нажатии на кнопку "Купить"
     */
    sendCheckoutEvent: function () {
      if (!this.model.get('qty')) {
        this.increaseQty();
      }
      if (!this.atAddToCartProcess) {
        if (app.isMobile){
          app.helpers.RedirectHelper.locationAssign('/checkout-service/' + this.item.get('sid'));
        }

        var qty = 0;
        if (this.model){
          qty = this.model.get('qty');
        }

        var wishItem = app.wish.get(this.item.get('id')) || '';
        this.item.set('wish_item', wishItem);
        this.item.set('qty', qty);
        Backbone.trigger('service-checkout:proceed', this.item );
      }
      this.removeFromCart();
      this.updateOnSync(this.model, 'update');
    }
  });
})(jQuery);

}.call(window));